export default "__VITE_ASSET__DNaEAZGS__"